import { type ShallowRef, computed, shallowRef } from 'vue';

export function getRefName(name: string): string {
  return `SessionStorageRef_${name}`;
}

export function useSessionStorageRef<T>(name: string, defaultValue: T): ShallowRef<T> {
  const defaultValueStr = JSON.stringify(defaultValue);
  const refName = getRefName(name);
  const valueStr = shallowRef(sessionStorage.getItem(refName) ?? defaultValueStr);
  const valueRef = computed<T>({
    get() {
      return JSON.parse(valueStr.value);
    },
    set(value) {
      valueStr.value = JSON.stringify(value);
      sessionStorage.setItem(refName, valueStr.value);
    },
  });
  return valueRef;
}
